<script setup lang="ts">
interface Props {
  space?: string;
}

withDefaults(defineProps<Props>(), {
  space: '24px',
});
</script>

<template>
  <div :class="[$style.wrapper]" :style="{ marginBottom: space }">
    <slot />
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

.wrapper {
  width: 100%;

  button {
    width: 100%;
  }

  select {
    width: 100%;
  }

  @include grid-media-query(sm) {
    button {
      width: auto;
    }

    width: 100%;
  }
}
</style>
